module.exports = __webpack_public_path__ + "static/1-2d586b7427dee07aa62e47178504d9ba.jpeg";